import { ErrorMessage, Field, Formik } from "formik";
import React, { useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Texterror } from "../../../constants/Texterror";
import { getSession } from "../../../redux/actions/authActions";

import { createService } from "../../../redux/actions/dbactions/ServicesActions";
import { serviceFormVadidations } from "../../../constants/Validation";
import commObj from "../../../constants/Common";
import { Icon } from "@iconify/react";

export const AddModal = ({
  show,
  setAddmodal,
  setRefresh,
  onHide,
  serviceid,
}) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.serviceList);
  const { user_profile_id, role_id } = getSession();
  const { refsdata } = useSelector((state) => state.refstypes);

  const [selectedImage, setSelectedImage] = useState(null);

  const serviceTypes = refsdata.usr?.service_type || [];
  const serviceCategories = refsdata.usr?.service_cat_type || [];
  const currencyTypes = refsdata.usr?.iso_currency || [];
  const xchange_rate = refsdata.usr?.iso_currency_xchng || [];
  const gross_margin = refsdata.usr?.service_gross_margin || [];

  const handleProviderCostChange = (e, setFieldValue) => {
    const value = parseFloat(e.target.value) || 0;
    setFieldValue("svc_provider_cost_amt", value);
    // const grossMargin = gross_margin[0]?.svc_gross_margin_pcnt || 0;
    const grossMargin = commObj.getTierMarging(
      value,
      gross_margin[0]?.svc_tier_cost_pct
    );
    const exchangeRate = xchange_rate[0]?.xchng_rate || 1;
    const svcCostAmt = value + value * grossMargin;
    const svcProviderLocalCostAmt = svcCostAmt * exchangeRate;
    setFieldValue("svc_cost_amt", svcCostAmt);
    setFieldValue("svc_provider_local_cost_amt", svcProviderLocalCostAmt);
  };

  const handleServiceChange = (event, setFieldValue) => {
    const newServiceId = event.target.value;
    setFieldValue("svc_typ_id", newServiceId);
  };

  const handleServiceCategory = (event, setFieldValue) => {
    const newServiceCateogryId = event.target.value;

    setFieldValue("svc_cat_id", newServiceCateogryId);
  };
  const handleCurrency = (event, setFieldValue) => {
    const newCurrencyId = event.target.value;

    setFieldValue("svc_curr_cde_id", newCurrencyId);
  };
  const newService = (values) => {
    values.xchange_rate = xchange_rate[0]?.xchng_rate;
    dispatch(createService(values));
    setRefresh(true);
    setAddmodal(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {};
    if (file) {
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append("files", file);
    }
  };

  return (
    <Modal className="edit_modal profile" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <h5 className="mb-0">{`Add Service`}</h5>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            svc_name: "",
            svc_desc: "",
            svc_cost_amt: 0,
            svc_svcf_id: serviceid,
            svc_typ_id: "",
            svc_cat_id: "",
            svc_curr_cde_id: "",
            svc_provider_local_cost_amt: 0,
            svc_provider_cost_amt: 0,
            sys_user_id: user_profile_id,
            role_id: role_id,
            svc_active_yn: "Y",
            svc_cost_unit_typ_id: 1,
          }}
          validationSchema={serviceFormVadidations}
          onSubmit={(values) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
              formData.append(key, values[key]);
            });
            if (selectedImage) {
              formData.append("services", selectedImage);
            }
            newService(formData);
          }}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <label
                    htmlFor="fileInput"
                    className="image_up mb-2 !rounded-md !h-20"
                  >
                    {selectedImage ? (
                      <div className="image-preview !items-center">
                        <img
                          src={URL.createObjectURL(selectedImage)}
                          alt="Preview"
                        />
                      </div>
                    ) : (
                      <>
                        <div className="open_upload">
                          <Icon
                            icon="line-md:upload-loop"
                            className="mx-auto"
                          />
                          <p>Upload Image</p>
                          <input
                            type="file"
                            accept="image/*"
                            id="fileInput"
                            style={{ display: "none" }}
                            onChange={handleImageChange}
                            name="services"
                          />
                        </div>
                      </>
                    )}
                  </label>
                  <div style={{ textAlign: "center", marginBottom: "20px" }}>
                    <ErrorMessage name="services" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  {" "}
                  <div className="mb-3">
                    <Field
                      className={`form-control ${
                        touched.svc_name && errors.svc_name ? "is-invalid" : ""
                      }`}
                      name="svc_name"
                      placeholder="Service Title"
                      type="input"
                      value={values.svc_name}
                    />
                    <ErrorMessage name="svc_name" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  {" "}
                  <div className="mb-3">
                    <Field
                      as={"textarea"}
                      rows={6}
                      className={`form-control ${
                        touched.svc_desc && errors.svc_desc ? "is-invalid" : ""
                      }`}
                      name="svc_desc"
                      placeholder="Service Description"
                      type="input"
                      value={values.svc_desc}
                    />
                    <ErrorMessage name="svc_desc" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Select
                      className="form-control"
                      name="svc_typ_id"
                      aria-label="Default select example"
                      onChange={(e) => handleServiceChange(e, setFieldValue)}
                      value={values.svc_typ_id}
                    >
                      <option>Select Service Type</option>
                      {serviceTypes.map((item, index) => (
                        <option key={index} value={item.svc_typ_id}>
                          {item.svc_typ_desc}
                        </option>
                      ))}
                    </Form.Select>

                    <ErrorMessage name="svc_typ_id" component={Texterror} />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Select
                      className="form-control"
                      name="svc_cat_id"
                      aria-label="Default select example"
                      onChange={(e) => handleServiceCategory(e, setFieldValue)}
                      value={values.svc_cat_id}
                    >
                      <option value="">Select Service Category</option>
                      {serviceCategories.map((item, index) => (
                        <option key={index} value={item.svc_cat_id}>
                          {item.svc_cat_desc}
                        </option>
                      ))}
                    </Form.Select>

                    <ErrorMessage name="svc_cat_id" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Select
                      className="form-control"
                      name="svc_curr_cde_id"
                      aria-label="Default select example"
                      onChange={(e) => handleCurrency(e, setFieldValue)}
                      value={values.svc_curr_cde_id}
                    >
                      <option value="">{"Select Currency"}</option>
                      {currencyTypes.map((item, index) => (
                        <option key={index} value={item.iso_curr_id}>
                          {`${item.iso_curr_name}  ${item.iso_curr_cde} `}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage
                      name="svc_curr_cde_id"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Field
                      className={`form-control ${
                        touched.svc_provider_cost_amt &&
                        errors.svc_provider_cost_amt
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_provider_cost_amt"
                      placeholder="Service Provider Cost (USD)"
                      type="number"
                      onChange={(e) =>
                        handleProviderCostChange(e, setFieldValue)
                      }
                      value={values.svc_provider_cost_amt}
                    />
                    <ErrorMessage
                      name="svc_provider_cost_amt"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Service Cost (USD)</Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_cost_amt && errors.svc_cost_amt
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_cost_amt"
                      placeholder="Service Cost (USD)"
                      type="number"
                      disabled={true}
                    />
                    <ErrorMessage name="svc_cost_amt" component={Texterror} />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>
                      {xchange_rate[0]?.iso_curr_name}@
                      {xchange_rate[0]?.xchng_rate}
                    </Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_provider_local_cost_amt &&
                        errors.svc_provider_local_cost_amt
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_provider_local_cost_amt"
                      placeholder={xchange_rate[0]?.iso_curr_name}
                      type="input"
                      disabled={true}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mini_edit">
                    <Button
                      className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
                      variant="secondary"
                      onClick={onHide}
                    >
                      Cancel
                    </Button>

                    <Button
                      className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
                      variant="primary"
                      type="submit"
                    >
                      {isLoading ? <Spinner /> : "Submit"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
